import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("cw_token")) {
      localStorage.removeItem("cw_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (path) =>
  `${API}/files/${path}?auth=${localStorage.getItem("cw_token")}`;

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s.includes("T") ? s : s + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export async function streamPayChat({ employeeId, message, sessionId, onDelta, onDone, onSession, onError }) {
  const resp = await fetch(`${API}/ai/pay-chat`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("cw_token")}`,
    },
    body: JSON.stringify({ employee_id: employeeId, message, session_id: sessionId }),
  });
  if (!resp.ok) {
    onError?.(`Request failed (${resp.status})`);
    return;
  }
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n\n");
    buffer = lines.pop();
    for (const line of lines) {
      if (!line.startsWith("data: ")) continue;
      try {
        const ev = JSON.parse(line.slice(6));
        if (ev.type === "delta") onDelta?.(ev.content);
        else if (ev.type === "session") onSession?.(ev.session_id);
        else if (ev.type === "done") onDone?.(ev);
        else if (ev.type === "error") onError?.(ev.message);
      } catch (e) { /* partial frame */ }
    }
  }
}
